export function clearBasket() {
    const deleteBtn = document.querySelector('.__delete_basket_selected');
    if(!deleteBtn) return;
    deleteBtn.addEventListener('click',()=>{
        sendData({}, '/api/cart/clear_cart/').then(res => {
            window.location.reload();
        })
    });
    const basketList = document.querySelector('.__basket_append');
    const deleteButtons = basketList.querySelectorAll('.__delete_basket__btn');
    deleteButtons.forEach(btn=>{
        const product_id = btn.dataset.id
        btn.addEventListener('click',()=> {
            sendData({'cart_product_id': product_id}, '/api/cart/delete_product/').then(res=>{
                window.location.reload();
            })
        })
    })

    async function sendData(data, url) {
        const csrfToken = document.querySelector('[name=csrfmiddlewaretoken]').value;
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    'Content-Type': "application/json",
                    'X-CSRFToken': csrfToken
                },
                body: JSON.stringify(data),
            });

            if (response.ok) {
                const result = await response.json();
                console.log(result);
            } else {
                throw new Error(response.statusText);
            }
        } catch (error) {
            console.error("Ошибка при отправке данных:", error);
        }
    }
}
